import { logger } from '@/logger'
import type { VideoJsPlayer } from '@setplex/player'
import { useCallback, useEffect, useState } from 'react'
import type { NpawPlayerOptions } from '~/features/npaw'
import { initNpawPlugin } from '../model'

// todo "options:" should be VideoJsPlayerOptions but type removed from video.js 8.0
export type initNpawParams = {
  playerInstance: VideoJsPlayer
  options: Record<never, never>
}
export type initNpawType = ({ playerInstance, options }: initNpawParams) => void

export function useNpaw(
  npawData: NpawPlayerOptions | null,
  enable: boolean = true
) {
  const [npawPlugin, setNpawPlugin] = useState<ReturnType<
    typeof initNpawPlugin
  > | null>(null)
  const [playerInfo, setPlayerInfo] = useState<initNpawParams | null>(null)

  const clearNpaw = useCallback(() => {
    if (npawPlugin) {
      npawPlugin.removeAdapter()
      setNpawPlugin(null)
    }
  }, [npawPlugin])

  const initNpaw = useCallback(
    (playerInfo: initNpawParams) => {
      setPlayerInfo(playerInfo)

      const { playerInstance, options } = playerInfo

      if (!enable || !playerInstance || !npawData || npawPlugin) return

      const sourceUrl = playerInstance.currentSrc()

      const video = {
        sourceUrl,
        ...options,
      }
      try {
        setNpawPlugin(initNpawPlugin(playerInstance, npawData, video))
      } catch (e) {
        logger.error('initNpawPlugin issue: ', e)
      }
    },
    [enable, npawData, npawPlugin]
  )

  useEffect(() => {
    if (enable && npawData && playerInfo && !npawPlugin) initNpaw(playerInfo)
  }, [enable, initNpaw, npawData, npawPlugin, playerInfo])

  return { initNpaw, clearNpaw }
}
